"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILEventDetail = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var enums_1 = require("../../shared/enums");
var common_components_1 = require("../event-timeoff-form/common.components");
var icon_1 = require("../icon/icon");
var typeography_common_1 = require("../typeography/typeography.common");
function dateFormatter(date, formatter) {
    if (formatter === void 0) { formatter = 'MM/dd/yyyy'; }
    return (0, date_fns_1.format)(date, formatter);
}
function ILEventDetail(_a) {
    var className = _a.className, iconSx = _a.iconSx, sx = _a.sx, students = _a.students, _b = _a.showDelete, showDelete = _b === void 0 ? true : _b, onDelete = _a.onDelete, _c = _a.showEdit, showEdit = _c === void 0 ? true : _c, onEdit = _a.onEdit, event = _a.event;
    var sameDay = (0, date_fns_1.isSameDay)(new Date(event.assignedDate), new Date(event.completedDate));
    return (react_1.default.createElement(material_1.Box, { className: 'il-event-detail ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', mb: '1.25rem', height: '100%' }, sx) },
        react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(typeography_common_1.ILH3, { sx: { textAlign: 'center', mb: '2.25rem' } }, "Event Details"),
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                } },
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        gap: '0.5rem',
                    } },
                    react_1.default.createElement(icon_1.Icon, { icon: event.eventIcon, sx: __assign({ color: 'primary.main', display: 'flex', alignItems: 'center' }, iconSx), dataTestId: "event-icon", size: enums_1.IconSizeEnum.XLARGE }),
                    react_1.default.createElement(material_1.Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '0.5rem',
                        } },
                        react_1.default.createElement(typeography_common_1.ILH5, { sx: {
                                fontSize: '1.125rem',
                            } }, event.title),
                        react_1.default.createElement(material_1.Box, { sx: {
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '0.375rem',
                                alignItems: 'center',
                            } },
                            react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.CALENDAR, sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: 'secondary.main',
                                    '& svg': {
                                        height: '1rem',
                                        width: '1rem',
                                    },
                                } }),
                            react_1.default.createElement(typeography_common_1.ILBody1, { sx: { fontSize: '0.8125rem', color: 'text.primary' } }, sameDay ? (react_1.default.createElement(react_1.default.Fragment, null, dateFormatter(new Date(event.assignedDate)))) : (react_1.default.createElement(react_1.default.Fragment, null,
                                dateFormatter(new Date(event.assignedDate)),
                                ' - ',
                                dateFormatter(new Date(event.completedDate)))))))),
                showEdit && (react_1.default.createElement(material_1.Button, { variant: "text", color: "info", onClick: function () {
                        onEdit && onEdit(event);
                    } }, "Edit"))),
            event.note && react_1.default.createElement(material_1.Divider, { sx: { mt: '1.75rem', mb: '1rem' } }),
            event.note && (react_1.default.createElement(typeography_common_1.ILBody1, { sx: { fontSize: '0.8125rem', color: 'text.secondary' } }, event.note)),
            react_1.default.createElement(material_1.Divider, { sx: { my: '1rem' } }),
            react_1.default.createElement(material_1.List, { sx: { p: 0 } }, students.map(function (student) { return (react_1.default.createElement(material_1.ListItem, { disablePadding: true, key: student.guid, "aria-label": "menuitem ".concat(student.firstName), sx: {
                    color: 'text.primary',
                    '& .MuiListItemText-root .MuiTypography-root': {
                        fontSize: '1rem',
                    },
                    '& .MuiAvatar-root': {
                        width: '1.5rem',
                        height: '1.5rem',
                    },
                    '& .MuiListItemAvatar-root': {
                        minWidth: '2rem',
                    },
                    px: '0.5rem',
                    py: '0.25rem',
                } },
                react_1.default.createElement(common_components_1.RenderStudentItem, { student: student }))); }))),
        showDelete && (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column' } },
            react_1.default.createElement(material_1.Divider, { sx: { my: '1rem' } }),
            react_1.default.createElement(material_1.Button, { variant: "text", color: "error", sx: { mt: '0.25rem', mb: '0.5rem' }, onClick: function () {
                    onDelete && onDelete(event);
                } }, "Delete Event")))));
}
exports.ILEventDetail = ILEventDetail;
